import { Route, Routes } from 'react-router-dom'
import * as React from 'react'
import ScreenManageCollections from '../../../Pages/Screen/ManageCollections/ScreenManageCollections'
import CreateCollections from '../../../Pages/Screen/New&Clone/CreateCollections'
import CreateScreen from '../../../Pages/Screen/New&Clone/CreateScreen'

function SelectedScreenRouter() {
  return (
    <Routes>
      <Route
        index
        element={<ScreenManageCollections />}
      />
      <Route
        path="collections"
        element={<CreateCollections />}
      />
      <Route path="clone">
        <Route
          index
          element={<CreateScreen clone={true} />}
        />
        <Route
          path="collections/:clone_id"
          element={<CreateCollections clone={true} />}
        />
        <Route
          path={'*'}
          element={<CreateScreen clone={true} />}
        />
      </Route>
    </Routes>
  )
}

export default SelectedScreenRouter
